// packages/integrations/lovable/src/LovableProvider.tsx

import { createContext, useContext, type ReactNode, type FC } from 'react';
import { useLovable } from './hooks/useLovable';

export interface LovableContextType {
  initialized: boolean;
}

const LovableContext = createContext<LovableContextType | undefined>(undefined);

export const useLovableContext = (): LovableContextType => {
  const context = useContext(LovableContext);
  if (!context) {
    throw new Error('useLovableContext must be used within a LovableProvider');
  }
  return context;
};

export interface LovableProviderProps {
  children: ReactNode;
}

export const LovableProvider: FC<LovableProviderProps> = ({ children }) => {
  const { initialized } = useLovable();

  return <LovableContext.Provider value={{ initialized }}>{children}</LovableContext.Provider>;
};

export default LovableProvider;
